import React from "react";

const PaymentOptionsList = ({ children }) => (
  <div className="payment-options options-list mt-4">{children}</div>
);

export default PaymentOptionsList;
